import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "attendeeList",
    "guestTemplate",
    "actionItemList",
    "actionItemTemplate",
    "attendeeRow",
    "actionItemRow",
    "incidentRow",
    "incidentCheckbox",
    "incidentNotes",
    "destroyField",
    "absenceReason"
  ]

  addGuest(event) {
    event.preventDefault()
    if (!this.hasGuestTemplateTarget) return

    const content = this.guestTemplateTarget.innerHTML.replace(/NEW_GUEST/g, Date.now())
    this.attendeeListTarget.insertAdjacentHTML("beforeend", content)
  }

  addActionItem(event) {
    event.preventDefault()
    if (!this.hasActionItemTemplateTarget) return

    const content = this.actionItemTemplateTarget.innerHTML.replace(/NEW_ACTION_ITEM/g, Date.now())
    this.actionItemListTarget.insertAdjacentHTML("beforeend", content)
  }

  removeRow(event) {
    event.preventDefault()
    const row = event.target.closest("[data-cqi-meeting-form-target='attendeeRow'], [data-cqi-meeting-form-target='actionItemRow']")
    if (!row) return

    const destroyField = row.querySelector("[data-cqi-meeting-form-target='destroyField']")
    if (destroyField) {
      destroyField.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }
  }

  toggleAbsenceReason(event) {
    const row = event.target.closest("[data-cqi-meeting-form-target='attendeeRow']")
    if (!row) return

    const reason = row.querySelector("[data-cqi-meeting-form-target='absenceReason']")
    if (!reason) return

    if (event.target.checked) {
      reason.classList.add("hidden")
    } else {
      reason.classList.remove("hidden")
    }
  }

  toggleIncident(event) {
    const row = event.target.closest("[data-cqi-meeting-form-target='incidentRow']")
    if (!row) return

    const destroyField = row.querySelector("[data-cqi-meeting-form-target='destroyField']")
    const notes = row.querySelector("[data-cqi-meeting-form-target='incidentNotes']")

    if (event.target.checked) {
      if (destroyField) destroyField.value = "0"
      if (notes) notes.classList.remove("hidden")
    } else {
      if (destroyField) destroyField.value = "1"
      if (notes) notes.classList.add("hidden")
    }
  }
}
